// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__Yje1u","grid":"Delivery_grid__c6WW1","header":"Delivery_header__XJhW8","goBack":"Delivery_goBack__blFtB","container":"Delivery_container__SifS1"};